import { styled } from "styled-components";

const Label = styled.label`
    display: block!important;
    font-size: 1.125rem!important;
    line-height: 1.5rem!important;
    font-weight: 700!important;
    color: #ffffff!important;
    font-family: "Red Hat Display"!important;
`;

const RadioLabel = styled.label`
    margin-left: 0.75rem!important;
    display: block!important;
    font-size: 0.875rem!important;
    line-height: 1.5rem!important;
    font-weight: 500!important;
    white-space: nowrap!important;
    font-family: "Red Hat Display"!important;
`;

const Fieldset = styled.fieldset`
    margint-top: 1rem;
    border: 0;
    padding: 0;
`

export default function FilterRadioInput({ costs_filter_data, onSelected, selectedValue, className }) {
    return (
        <div className={`se-text-sneutral-450 ${className}`}>
            <Label>Cost per hour</Label>
            <Fieldset>
                <div className="se-space-y-1">
                    {costs_filter_data.map((item) => (
                        <div
                            key={item.join("-")}
                            className="se-flex se-items-center">
                            <input
                                id={item.join("-")}
                                value={item.join("-")}
                                name="notification-method"
                                type="radio"
                                className="se-h-4 w-4 se-border-gray-300 se-border-solid se-border checked:!se-bg-sorange-40 hover:!se-bg-sorange-40 checked:hover:!se-bg-sorange-40"
                                checked={selectedValue == item.join("-")}
                                onChange={onSelected}
                            />
                            <RadioLabel htmlFor={item.join("-")}>${item.join(" - $")}</RadioLabel>
                        </div>
                    ))}
                    <div className="se-flex se-items-center">
                        <input
                            id="show-all"
                            value=""
                            name="notification-method"
                            type="radio"
                            className="se-h-4 w-4 se-border-gray-300 se-border-solid se-border checked:!se-bg-sorange-40 hover:!se-bg-sorange-40 checked:hover:!se-bg-sorange-40"
                            checked={selectedValue == ""}
                            onChange={onSelected}
                        />
                        <RadioLabel htmlFor="show-all">Show All</RadioLabel>
                    </div>
                </div>
            </Fieldset>
        </div>
    );
}
